import { Observable } from 'rxjs';
import { CursorPage, GraphUser, GraphUserSearchQuery } from '@gbr-monorepo/interfaces';

/**
 * Contract for directory (Microsoft Graph users) operations required by the
 * user-management UI internals. Used as both the TypeScript type and the
 * Angular dependency-injection token. Host applications supply a concrete
 * implementation via `provideUserManagement(...)`.
 */
export abstract class GraphUserServiceContract {
    /** GET the directory page endpoint with the given search criteria, returning a cursor page. */
    public abstract findUsers(search: GraphUserSearchQuery): Observable<CursorPage<GraphUser>>;

    /** GET the directory endpoint with an exact employee ID lookup, returning the first match (or undefined). */
    public abstract getUserByEmployeeId(employeeId: string): Observable<GraphUser | undefined>;

    /** GET the directory endpoint with an exact email lookup, returning the first match (or undefined). */
    public abstract getUserByEmail(email: string): Observable<GraphUser | undefined>;
}
